import { resources } from "@constants/hardcoded-strings";
import {
    AXNUIContent
} from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingKbaFormValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingKbaFormValidationErrors = (
    isUsingThemedUI: boolean,
    showKbaFormTab: boolean,
    axnuiContent: AXNUIContent
): ThemingKbaFormValidationErrors => {
    let count = 0;
    let helloMessageError = null;
    let retryMessageError = null;

    if (isUsingThemedUI && showKbaFormTab) {
        if (!axnuiContent.kba.helloMessage) {
            count += 1;
            helloMessageError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.kba.retryMessage) {
            count += 1;
            retryMessageError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
    }

    return {
        helloMessageError,
        retryMessageError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.kbaForm.tabName}
            errorCount={count}
        />
    };
};